import { customRailsDirectUploadsPath } from '../../../javascript/application/ts_routes';
import { Blob, DirectUpload } from '../../../vendor/activestorage';

interface DirectUploadBlob extends Blob {}

interface ErrorWithAdditionalData {
  error: Error;
  additionalData: {
    status?: number;
    fileName?: string;
    event?: Event;
  };
}

export const directUpload = (file: File, onProgress?: (progress: number) => void) => {
  const directUploadDidProgress = (event: ProgressEvent) => {
    const percent = Math.round((event.loaded / event.total) * 100);
    if (typeof onProgress === 'function') {
      onProgress(percent);
    }
  };

  const directUploadWillStoreFileWithXHR = (xhr: XMLHttpRequest) => {
    xhr.upload.addEventListener('progress', (event) => directUploadDidProgress(event));
  };

  const directUpload = new DirectUpload(file, customRailsDirectUploadsPath(), { directUploadWillStoreFileWithXHR });

  return new Promise<DirectUploadBlob>((resolve, reject) => {
    directUpload.create((error, blob) => {
      // Blob is only set on success, error is only set on error.
      if (error) {
        reject(error);
      } else {
        resolve(blob);
      }
    });
  });
};

export type { DirectUploadBlob, ErrorWithAdditionalData };
